export const getSelectedIds = (selectedIds: Record<string, boolean>): string[] => {
  return Object.entries(selectedIds)
    .filter(([, value]) => Boolean(value))
    .map(([key]) => key);
};
